var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfileLocation = function SvgProfileLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 0C6.95632 0 3.6665 3.28982 3.6665 7.33335C3.6665 8.54722 3.96999 9.75077 4.54693 10.8183L10.5988 21.7637C10.6794 21.9096 10.8329 22 10.9999 22C11.1668 22 11.3203 21.9096 11.4009 21.7637L17.455 10.8147C18.0297 9.75077 18.3332 8.54717 18.3332 7.3333C18.3332 3.28982 15.0434 0 10.9999 0ZM10.9999 11C8.97809 11 7.3332 9.35511 7.3332 7.33335C7.3332 5.31158 8.97809 3.6667 10.9999 3.6667C13.0216 3.6667 14.6665 5.31158 14.6665 7.33335C14.6665 9.35511 13.0216 11 10.9999 11Z",
    fill: "#8F97B9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile_location.59bea8da.svg";
export { ForwardRef as ReactComponent };